import StyledArrayFieldTemplate from "./StyledArrayFieldTemplate";

export default StyledArrayFieldTemplate;